import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

// Module-level guard so HMR/StrictMode doesn't fire the verify twice
const fired = new Set();

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading");
  const [message, setMessage] = useState("");

  // "Derived effect during render" pattern: fire exactly once for this token
  if (!fired.has(token)) {
    fired.add(token);
    if (!token) {
      setState("error");
      setMessage("Kein Token in der URL.");
    } else {
      // Fire-and-forget async verification
      (async () => {
        try {
          await api.post("/auth/verify-email", { token });
          setState("success");
          setMessage("E-Mail erfolgreich bestätigt.");
        } catch (e) {
          const d = e.response?.data?.detail;
          setMessage(typeof d === "string" ? d : "Bestätigung fehlgeschlagen.");
          setState("error");
        }
      })();
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="verify-email-page">
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 max-w-md w-full p-10 text-center">
        {state === "loading" && (
          <>
            <Loader2 className="w-12 h-12 mx-auto text-orange-500 animate-spin" />
            <h1 className="mt-4 text-2xl font-bold text-slate-900">E-Mail wird bestätigt…</h1>
          </>
        )}
        {state === "success" && (
          <>
            <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-500" />
            <h1 className="mt-4 text-2xl font-bold text-slate-900" data-testid="verify-success">E-Mail bestätigt!</h1>
            <p className="mt-2 text-slate-600">{message}</p>
            <Link to="/dashboard" className="mt-6 inline-block bg-orange-600 hover:bg-orange-700 text-white px-6 py-2.5 rounded-md font-semibold transition" data-testid="verify-go-dashboard">
              Zum Dashboard →
            </Link>
          </>
        )}
        {state === "error" && (
          <>
            <AlertCircle className="w-12 h-12 mx-auto text-red-500" />
            <h1 className="mt-4 text-2xl font-bold text-slate-900" data-testid="verify-error">Bestätigung fehlgeschlagen</h1>
            <p className="mt-2 text-slate-600">{message}</p>
            <Link to="/login" className="mt-6 inline-block text-orange-600 hover:text-orange-700 font-semibold" data-testid="verify-back-login">
              ← Zurück zur Anmeldung
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
